import { InjectedStyledComponent } from '../../../../../shared/InjectedStyledComponent.js';
import { DATE_PICKER_CATEGORY_KEY, DATE_PICKER_COMPONENT_KEY } from '../../DatePicker.meta.js';
import { datePickerStyle } from '../../styles/DatePicker.style.js';

export default InjectedStyledComponent(
	'th',
	DATE_PICKER_CATEGORY_KEY,
	DATE_PICKER_COMPONENT_KEY,
	['tableHeadCell'],
	undefined,
	undefined,
	datePickerStyle.children?.tableHeadCell,
);
